import Swup from "swup";
import SwupA11yPlugin from "@swup/a11y-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Modules
import { closeNav } from "./modules/navigation.js";
import initSwiper from "./modules/swiper.js";
import initAnimateOnScroll from "./modules/animateOnScroll.js";

const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

const initAll = () => {
  initSwiper();

  if (!prefersReducedMotion) {
    initAnimateOnScroll();
  }
};

initAll();

const swupContainer = document.querySelector("#swup");

if (swupContainer) {
  const swup = new Swup({
    containers: ["#swup"],
    linkToSelf: "navigate",
    plugins: [
      new SwupHeadPlugin({
        awaitAssets: true,
        persistTags: true,
      }),
      new SwupA11yPlugin(),
      new SwupScrollPlugin({
        animateScroll: {
          betweenPages: false,
          samePageWithHash: !prefersReducedMotion,
          samePage: false,
        },
      }),
    ],
  });

  swup.hooks.on("page:view", () => {
    initAll();
  });

  swup.hooks.on("visit:start", () => {
    closeNav();
    ScrollTrigger.killAll();
  });
}
